import { render, staticRenderFns } from "./OpenBillingContactTable.vue?vue&type=template&id=3cb40608&scoped=true&"
import script from "./OpenBillingContactTable.vue?vue&type=script&lang=js&"
export * from "./OpenBillingContactTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb40608",
  null
  
)

export default component.exports